/* eslint-disable no-console, react/prop-types */
import React from 'react';
import {
  Pie,
  ResponsiveContainer,
  PieChart as PieReChart,
  Cell,
  Label
} from 'recharts';

import {pairsOfColour} from '../../../pages/netZero/constants/commonConstants';

import renderCustomizedLabel from './utils/RenderCustomLabelSingle';

const SemiDonutChart: React.FC<{
  data: any[];
  showLabel?: boolean;
  noStrokeWidth?: boolean;
  centerLabel?: {title: string; value: string; unit: string};
}> = ({data, showLabel = true, centerLabel}) => {
  const colorPalette = pairsOfColour.flat();

  const chartData = data?.every((item: any) => {
    return item?.value === 0 || typeof item?.value !== 'number';
  })
    ? [{value: 100, fill: '#E0EFFD'}]
    : data ?? [];

  const renderCenterLabel = (props: unknown): React.ReactNode => {
    const p = props as {viewBox?: {cx?: number; cy?: number}};
    const cx = p?.viewBox?.cx;
    const cy = p?.viewBox?.cy;

    if (!centerLabel || typeof cx !== 'number' || typeof cy !== 'number') {
      return null;
    }

    return (
      <text
        x={cx}
        y={cy}
        textAnchor="middle"
        dominantBaseline="central"
        style={{pointerEvents: 'none'}}
      >
        <tspan x={cx} dy={-50} fill="#7B8190" fontSize={18} fontWeight={500}>
          {centerLabel.title}
        </tspan>

        <tspan x={cx} dy={22} fill="#2B2F38" fontSize={22} fontWeight={600}>
          {centerLabel.value}
          <tspan dx={6} fill="#2B2F38" fontSize={16} fontWeight={500}>
            {centerLabel.unit}
          </tspan>
        </tspan>
      </text>
    );
  };

  return (
    <div style={{width: '100%', height: '100%'}}>
      <ResponsiveContainer width="100%" height="100%">
        <PieReChart width={500} height={500}>
          <Pie
            data={chartData}
            cx="50%"
            cy="70%"
            startAngle={180}
            endAngle={0}
            innerRadius="85%"
            outerRadius="100%"
            cornerRadius={5}
            labelLine={false}
            label={showLabel ? renderCustomizedLabel : undefined}
            fill="#8884d8"
            dataKey="value"
            minAngle={5}
            strokeWidth={0}
            paddingAngle={7}
          >
            {chartData.map((entry, index) => (
              <Cell
                style={{outline: 'none'}}
                key={`cell-${index}`}
                fill={entry.fill ?? colorPalette[index % colorPalette.length]}
              />
            ))}
            {centerLabel && (
              <Label position="center" content={renderCenterLabel} />
            )}
          </Pie>
        </PieReChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SemiDonutChart;
